export default __webpack_public_path__ + "static/media/phone-2.45bf6729.png";